import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/interfaces/pcg-table-column.interface';

export class BA_SharedInboxVm {
	subscriptionSharedInboxId: number;
	email?: string;
	name?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'subscriptionSharedInboxId': new UntypedFormControl(0, [...(validators['subscriptionSharedInboxId'] ?? []), ...[Validators.required]]),
			'email': new UntypedFormControl(null, [...(validators['email'] ?? []), ...[Validators.required, Validators.email, Validators.pattern("^[A-Za-z0-9._%+'-]+@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*\\.[A-Za-z]{2,}$"), Validators.maxLength(256), Validators.minLength(0)]]),
			'name': new UntypedFormControl(null, [...(validators['name'] ?? []), ...[Validators.maxLength(100), Validators.minLength(0)]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): BA_SharedInboxVmFromFg {
		return new BA_SharedInboxVmFromFg(fg);
	}
}

export class BA_SharedInboxVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get subscriptionSharedInboxId(): number {
		return this.fg.get('subscriptionSharedInboxId').value;
	}
	set subscriptionSharedInboxId(val) {
		this.fg.get('subscriptionSharedInboxId').setValue(val);
	}

	get email(): string {
		return this.fg.get('email').value;
	}
	set email(val) {
		this.fg.get('email').setValue(val);
	}

	get name(): string {
		return this.fg.get('name').value;
	}
	set name(val) {
		this.fg.get('name').setValue(val);
	}
}
